var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex"},[(!_vm.fetchNextPageInProgress)?_c('gl-button',{attrs:{"category":"tertiary","variant":"confirm"},on:{"click":function($event){return _vm.$emit('fetch-next-page', $event)}}},[_vm._v("\n    "+_vm._s(_vm.s__('WorkItem|Load more')))]):_c('gl-loading-icon',{staticClass:"gl-ml-4 gl-py-2",attrs:{"size":"md"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }